import { createAsyncThunk } from "@reduxjs/toolkit";
import { AxiosError } from "axios";
import AXIOS from "../../../../config/api";
import { BASE_API } from "../../../../constants/apiUrls";
import { toast } from "../../../../lib/toast";
import {
  CommonOthers,
  ErrorMessage,
  GetCommonData,
  GetSingleDataParams,
  Params,
  PostRequest,
} from "../../../../types";
import {
  CreateCampaignData,
  GetCampaignData,
  GetCampaignDataParams,
  GetSingleCampaignData,
} from "../../../../types/eventManage/campaigns";
import { handleApiError } from "../../../../utils/errorHandler";

// create
export const createCampaignAsync = createAsyncThunk<
  null,
  PostRequest<CreateCampaignData, CommonOthers>
>(
  "admin/createCampaign",
  async ({ data, others: { reRender } }, { rejectWithValue }) => {
    try {
      await AXIOS.post(BASE_API.createCampaign, data);

      reRender(true);
      toast("success", "Campaign create successfully");
      return null;
    } catch (err) {
      const errors = err as AxiosError;
      const error = errors.response?.data as ErrorMessage;
      handleApiError(error, "Campaign create fail");
      return rejectWithValue(error);
    }
  }
);

// get all
export const getAllCampaignAsync = createAsyncThunk<
  GetCommonData<GetCampaignData>,
  Params<GetCampaignDataParams>,
  {
    rejectValue: ErrorMessage;
  }
>("admin/getAllCampaign", async ({ params }, { rejectWithValue }) => {
  const { ...rest } = params as GetCampaignDataParams;

  try {
    const data = await AXIOS.get(BASE_API.getAllCampaigns, {
      params: { ...rest },
      headers: {
        "ngrok-skip-browser-warning": true,
      },
    });

    return {
      data: data.data?.data,
      length: data.data?.totalCount,
    };
  } catch (err) {
    const errors = err as AxiosError;
    const error = errors.response?.data as ErrorMessage;
    handleApiError(error, "Get Campaign fail");
    return rejectWithValue(error);
  }
});

// update
export const updateCampaignAsync = createAsyncThunk<
  null,
  PostRequest<CreateCampaignData, GetSingleDataParams>
>(
  "admin/updateCampaign",
  async ({ data, others: { reRender, id } }, { rejectWithValue }) => {
    try {
      await AXIOS.patch(`${BASE_API.updateCampaign}/${id}`, data);

      reRender && reRender(true);
      toast("success", "Campaign update successfully");
      return null;
    } catch (err) {
      const errors = err as AxiosError;
      const error = errors.response?.data as ErrorMessage;
      handleApiError(error, "Campaign update fail");
      return rejectWithValue(error);
    }
  }
);

// single
export const singleCampaignDataAsync = createAsyncThunk<
  GetSingleCampaignData,
  Params<GetSingleDataParams>
>("admin/singleCampaignData", async ({ params }, { rejectWithValue }) => {
  try {
    const data = await AXIOS.get(
      `${BASE_API.getSingleCampaign}/${params?.id}`,
      {
        headers: {
          "ngrok-skip-browser-warning": true,
        },
      }
    );

    return data.data?.data;
  } catch (err) {
    const errors = err as AxiosError;
    const error = errors.response?.data as ErrorMessage;
    handleApiError(error, "Single Campaign data get fail");
    return rejectWithValue(error);
  }
});
